import { usePositionOptions } from "@/services/backend/omni/position/lib/use-position-options";
import { PositionsTable } from "../../position/components/positions-table";
import { ScopeOfWork } from "../../scope-of-work/types/scope-of-work";
import { useScopeOfWorkPositionsTableProps } from "../lib/use-scope-of-work-positions-table-props";
import { Offer } from "../types/offer";
import { omniPositionsTableConfig } from "../../servicekindrules/omni-positions-table-config";

/**
 * OfferScopeOfWorkPositionsTable shows and edits the positions of a scope
 * of work of the offer.
 */
export function OfferScopeOfWorkPositionsTable({
  offer,
  scopeOfWork,
}: {
  offer: Offer;
  scopeOfWork: ScopeOfWork;
}) {
  const props = useScopeOfWorkPositionsTableProps(offer, scopeOfWork);
  const options = usePositionOptions(
    offer.companyId,
    offer.serviceKind,
    scopeOfWork.serviceVariation,
  );

  return (
    <PositionsTable
      config={omniPositionsTableConfig(scopeOfWork.positions, options)}
      {...props}
    />
  );
}
